import React, { useEffect, useState } from 'react';
import ReactFlow, { ReactFlowProvider } from 'react-flow-renderer';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt } from 'react-icons/fa'; // Importing the map marker icon
import './flowchart.css'; // Ensure your CSS is defined here
import CustomNode from './imageHandler'; // Ensure CustomNode is correctly implemented
import 'react-flow-renderer/dist/style.css';

const ProductFlowChart = () => {
  // Initializing state for the animation
  const [markerPosition, setMarkerPosition] = useState({ x: 0, y: 0 });
  const [currentNodeIndex, setCurrentNodeIndex] = useState(0); // To track the node being animated
  const [containerWidth, setContainerWidth] = useState(window.innerWidth);
  const [containerHeight, setContainerHeight] = useState(window.innerHeight);

  // Update container size on window resize
  const handleResize = () => {
    setContainerWidth(window.innerWidth);
    setContainerHeight(window.innerHeight);
  };

  // Adjusted nodes with dynamic positioning for centering
  const nodes = [
    { id: '1', type: 'customNode', data: { label: 'PO from Customer', image: 'img/slider_img/order.jpg' }, position: { x: containerWidth /2 - 105, y: 50 }, draggable: false, sourcePosition: 'right' },
    { id: '2', type: 'customNode', data: { label: 'Product Quality Check', image: 'img/product_img/qualitymain.jpg' }, position: { x: containerWidth /2 - 115, y: 250 }, draggable: false, sourcePosition: 'left', targetPosition: 'top' },
    { id: '3', type: 'customNode', data: { label: 'Packaging', image: 'img/product_img/packing.jpg' }, position: { x: containerWidth /2 - 115, y: 450 }, draggable: false, sourcePosition: 'right', targetPosition: 'top' },
    { id: '4', type: 'customNode', data: { label: 'Delivery to Customer', image: 'img/product_img/delivery.jpg' }, position: { x: containerWidth /2 - 115, y: 650 }, draggable: false, targetPosition: 'left' },
  ];

  // Edges connecting the nodes
  const edges = [
    { id: 'e1-2', source: '1', target: '2', animated: true, style: { stroke: '#4CAF50' } },
    { id: 'e2-3', source: '2', target: '3', animated: true, style: { stroke: '#4CAF50' } },
    { id: 'e3-4', source: '3', target: '4', animated: true, style: { stroke: '#4CAF50' } },
  ];

  // Moving marker from node to node
  

  // Listen for window resize events and update container width and height
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <ReactFlowProvider>
      <div className="flowchart-container">
        <h2 className="flowchart-heading">Peru-Tech Product Delivery Process</h2>

        <div className="flowchart-reactflow">
          <ReactFlow
            nodes={nodes}
            edges={edges}
            nodeTypes={{ customNode: CustomNode }}
            zoom={false}
            pan={false}
            nodesDraggable={false}
            nodesConnectable={false}
            elementsSelectable={false}
            minZoom={1}
            maxZoom={1}
          />
        </div>

       
      </div>
    </ReactFlowProvider>
  );
};

export default ProductFlowChart;
